var _path, _mask, _path2, _mask2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineDesign1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 863,
    height: 10,
    viewBox: "0 0 863 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00366211 4.25L198.267 5.75L397.504 4.25",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_198_261",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.504 0H423.504V10H413.504V0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.504 0V-1H412.504V0H413.504ZM423.504 0H424.504V-1H423.504V0ZM423.504 10V11H424.504V10H423.504ZM413.504 10H412.504V11H413.504V10ZM413.504 0V1H423.504V0V-1H413.504V0ZM423.504 0H422.504V10H423.504H424.504V0H423.504ZM423.504 10V9H413.504V10V11H423.504V10ZM413.504 10H414.504V0H413.504H412.504V10H413.504Z",
    fill: "white",
    mask: "url(#path-2-inside-1_198_261)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_198_261",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.504 0H449.504V10H439.504V0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.504 0V-1H438.504V0H439.504ZM449.504 0H450.504V-1H449.504V0ZM449.504 10V11H450.504V10H449.504ZM439.504 10H438.504V11H439.504V10ZM439.504 0V1H449.504V0V-1H439.504V0ZM449.504 0H448.504V10H449.504H450.504V0H449.504ZM449.504 10V9H439.504V10V11H449.504V10ZM439.504 10H440.504V0H439.504H438.504V10H439.504Z",
    fill: "white",
    mask: "url(#path-4-inside-2_198_261)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.504 4.25L663.767 5.75L863.004 4.25",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDesign1);
export default __webpack_public_path__ + "static/media/line-design-1.de6823abe0d9c769216d0e4532efd112.svg";
export { ForwardRef as ReactComponent };